import { useEffect } from "react";
import type { DialogProps } from "@mui/material";
import { ModalBasic } from "../../../../../shared/components/ModalBasic";
import { FileContainer } from "../../../../Database/Components/FileContainer";
import { useAppDispatch } from "../../../../../services/redux/hooks/use-dispatch";
import { getLocalStoreFilesAction } from "../../../../Database/redux/actions/local_store_actions";
import { getStoreFilesAction } from "../../../../Database/redux/actions/openai_store_actions";
import { TStoreData } from "../../../../../services/api/instances/vectorStoreApi/types";
import { TModalsIds } from "../../../../../app/state/modalSlice/types";
import { useModalSelectors } from "../../../../../app/state/modalSlice/hook/use-modal-selectors";
import styles from "./styles.module.css";

interface Props extends Omit<DialogProps, "open"> {
  closeModal: (id: TModalsIds) => void;
  selectedStore: TStoreData | null;
}

export const AddFileToDatabaseModal = ({
  selectedStore,
  closeModal,
  ...rest
}: Props) => {
  const dispatch = useAppDispatch();
  const addFileModal = useModalSelectors("add_file_to_database");

  useEffect(() => {
    if (addFileModal.isOpen && selectedStore) {
      if (selectedStore.metadata.type === "local") {
        dispatch(getLocalStoreFilesAction(selectedStore.id));
      } else if (selectedStore.metadata.type === "openai") {
        dispatch(getStoreFilesAction(selectedStore.id));
      }
    }
  }, [addFileModal.isOpen]);

  return (
    <ModalBasic
      open={addFileModal.isOpen}
      title={"Добавление файлов в Базу знаний"}
      hasCloseButton
      onCancel={() => closeModal("add_file_to_database")}
      onClose={() => closeModal("add_file_to_database")}
      closeModal={() => closeModal("add_file_to_database")}
      onCancelText="Закрыть"
      hasFooter
      {...rest}
    >
      <div className={styles["body"]}>
        <FileContainer storeData={selectedStore} />
      </div>
    </ModalBasic>
  );
};
